import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useResponsiveLayout from '../../../../styles/responsive-layout.hook';
import ExistingClientButtonComponents from './existing-client-button.components';
import { PORTAL_TYPE } from '../../../../types/app.types';

interface ExistingClientButtonProps {
  mobileText: string;
  image: {
    path: string;
    alt: string;
  };
  handleOnClick: (portal: PORTAL_TYPE) => void;
  redirectPath: PORTAL_TYPE;
  highlighted: string;
}

const {
  Container,
  TopRow,
  Logo,
  Arrow,
  StyledText
} = ExistingClientButtonComponents;

const ExistingClientButton: React.FunctionComponent<ExistingClientButtonProps> = ({
  mobileText,
  image,
  handleOnClick,
  redirectPath,
  highlighted
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveLayout();

  const internalOnClick = useCallback(() => {
    handleOnClick(redirectPath);
  }, [handleOnClick, redirectPath]);

  return (
    <Container onClick={internalOnClick}>
      <TopRow>
        <Logo src={image.path} alt={t(image.alt)} />
        {isMobile && <Arrow />}
      </TopRow>
      <StyledText className="ucf-paragraph">
        <Trans
          i18nKey={mobileText}
          values={{ link: highlighted }}
          components={{ bold: <strong /> }}
        />
      </StyledText>
    </Container>
  );
};

export default ExistingClientButton;
